"use strict";exports.__esModule=true;exports.default=void 0;var enUS={dateTime:"%x, %X",date:"%-m/%-d/%Y",time:"%-I:%M:%S %p",periods:["AM","PM"],days:["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"],shortDays:["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],months:["January","February","March","April","May","June","July","August","September","October","November","December"],shortMonths:["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"]};var _default=enUS;exports.default=_default;


//////////////////
// WEBPACK FOOTER
// ./~/@fusioncharts/utils/src/time-converter/locales/en-US.js
// module id = 1Tfu
// module chunks = 5